import { GeneralMessage } from './GeneralMessage'

export default GeneralMessage
